import { Grid, Typography, useMediaQuery } from '@mui/material';
import React, { useEffect } from 'react';
import IndividualGuestsComponent from '../../components/GuestsManagement/IndividualGuestsComponent';

export default function IndividualGuestPage() {
    const isMobile = useMediaQuery('(max-width: 770px)');
    const isIpad = useMediaQuery('(max-width: 1200px)');

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Grid
            sx={{
                width: '100%',
                height: isMobile || isIpad ? '100%' : '80%',
                justifyContent: 'left',
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
            }}
        >
            <Grid
                sx={{
                    width: '100%',
                    justifyContent: 'left',
                    alignItems: 'center',
                }}
            >
                <Typography
                    variant='h1'
                    sx={{
                        textAlign: 'left',
                        textTransform: 'uppercase',
                    }}
                >
                    View Guest Company Users
                </Typography>
            </Grid>{' '}
            <Grid
                sx={{
                    width: '100%',
                    justifyContent: 'left',
                }}
            >
                <IndividualGuestsComponent />
            </Grid>
        </Grid>
    );
}
